import type { Questionnaire, QuestionnaireItem, QuestionnaireResponse, QuestionnaireResponseItem } from '@medplum/fhirtypes';
import { buildQuestionnaireTextFieldKey, isQuestionnaireTextInputItem } from './questionnaireTextFieldKey';

/**
 * Snapshot current text/string answer values keyed for undo after AI replace.
 * Does not read or write metadata or source resources.
 */
export function collectTextAnswerSnapshots(
  questionnaire: Questionnaire,
  response: QuestionnaireResponse | undefined,
): Map<string, string> {
  const out = new Map<string, string>();
  walk(
    questionnaire.item ?? [],
    response?.item ?? [],
    [],
    out,
  );
  return out;
}

function walk(
  qItems: QuestionnaireItem[],
  rItems: QuestionnaireResponseItem[],
  context: QuestionnaireResponseItem[],
  out: Map<string, string>,
): void {
  for (const qItem of qItems) {
    const rItem = rItems.find((r) => r.linkId === qItem.linkId);
    if (!rItem) continue;

    if (isQuestionnaireTextInputItem(qItem)) {
      if (qItem.repeats) {
        const answers = rItem.answer?.length ? rItem.answer : [{}];
        answers.forEach((ans, answerIndex) => {
          const key = buildQuestionnaireTextFieldKey(context, qItem.linkId, answerIndex);
          out.set(key, ans?.valueString ?? '');
        });
      } else {
        const key = buildQuestionnaireTextFieldKey(context, qItem.linkId, 0);
        out.set(key, rItem.answer?.[0]?.valueString ?? '');
      }
    }

    if (qItem.item?.length && rItem.item?.length) {
      walk(qItem.item, rItem.item, [...context, rItem], out);
    }
  }
}
